import React from "react";
import {Redirect, Route} from "react-router-dom";
import WS from "../ws";
/* import axios_base from '../axios_base'; */

const isAuth = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
        if (!WS.initialized) WS.init(token);
        return true;
    }
    // Operador: autenticado, mas SEM WS (o socket não é operator-scoped; degrada seguro).
    return localStorage.getItem("operator_session_token") !== null;
};

const PrivateRoute = ({component: Component, ...rest}) => {
    return (
        <Route
            {...rest}
            render={props =>
                isAuth() ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/unauthorized",
                            state: {message: "Usuário não autorizado"},
                        }}
                    />
                )}
        />
    );
};

export default PrivateRoute;